<template>
  <div v-if="computingInceptionDate">
    We are computing inception date
  </div>
  <div v-else>
    <div v-if="suggestedInceptionDate">
      <a-month-picker
        placeholder="Select period"
        v-model="inceptionDate"
        :disabled-date="disabledDate"
      />
    </div>
    <div v-else>
      <p>
        We have not been able to compute an inception date with a minimum of
        {{ MINIMUM_DATA_POINTS }} data points for the selected constituents.
      </p>
      <p>Please go back to previous step to select more constituents</p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  props: {
    constituents: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.MINIMUM_DATA_POINTS = 3
  },
  data() {
    return {
      computingInceptionDate: false,
      inceptionDate: null,
      suggestedInceptionDate: null,
    }
  },
  methods: {
    disabledDate(current) {
      return (
        this.suggestedInceptionDate &&
        current &&
        current < this.suggestedInceptionDate
      )
    },
    async getInceptionDate() {
      const result = await this.$apollo.query({
        query: gql`
          query GetSuggestedInceptionDate($constituents: [Uuid!]!) {
            suggestedInceptionDate(constituents: $constituents) {
              year
              month
            }
          }
        `,
        variables: {
          constituents: this.constituents.map((c) => c.class.key),
        },
      })
      const suggestedPeriod = result.data.suggestedInceptionDate
      return suggestedPeriod
        ? moment(
            `${suggestedPeriod.year}-${suggestedPeriod.month}-1`,
            'YYYY-M-D',
          )
        : null
    },
  },
  watch: {
    async constituents(newValue) {
      if (newValue && newValue.length >= this.MINIMUM_DATA_POINTS) {
        this.computingInceptionDate = true
        this.suggestedInceptionDate = await this.getInceptionDate(newValue)
        this.inceptionDate = this.suggestedInceptionDate
        this.computingInceptionDate = false
      } else {
        this.inceptionDate = null
      }
    },
    inceptionDate(newValue) {
      if (newValue) {
        this.$emit('inceptionDateChanged', {
          year: newValue.year(),
          month: newValue.month() + 1,
        })
      } else {
        this.$emit('inceptionDateChanged', {
          year: 0,
          month: 0,
        })
      }
    },
  },
}
</script>

<style></style>
